import { useContext, useMemo } from "react";
import { DataContext } from "providers/DataProvider";
import { useNavigate, useLocation } from "react-router-dom";
import { useNotificationPermission } from "providers/NotificationPermissionProvider";

import 'styles/BottomNavBar.css';

import { HomeIcon, CreateGroupIcon, PlusIcon, BellEnabledIcon, BellDisabledIcon } from "components/Icons";

export default function BottomNavBar(){

  const { me } = useContext(DataContext);
  const navigate = useNavigate();
  const location = useLocation();

  const { notificationsEnabled, toggleNotifications } = useNotificationPermission();

  const bottomNavBarStyle = useMemo(() => ({
    gridTemplateColumns: me?.email ? 'repeat(5,20%)' : 'repeat(3,33.333%)'
  }), [me])

  return (
    <div className="bottom-navbar" style={bottomNavBarStyle}>
      <button className={location.pathname === '/' ? 'active' : ''} onClick={()=>navigate('/')}>
        <HomeIcon />
      </button>
      {me?.email ? (
        <>
          <button className={location.pathname === '/create-group' ? 'active' : ''} onClick={()=>navigate('/create-group')}>
            <CreateGroupIcon />
          </button>
          <button className={location.pathname === '/create-activity' ? 'active' : ''} onClick={()=>navigate('/create-activity')}>
            <PlusIcon />
          </button>
          <button className={location.pathname === '/notifications' ? 'active' : ''} onClick={()=>navigate('/notifications')}>
            {notificationsEnabled ? <BellEnabledIcon /> : <BellDisabledIcon />}
          </button>
          <button className={"profile" + (location.pathname === '/profile' ? ' active' : '')} onClick={()=>navigate('/profile')}>
            <img src={me?.picture?.imageSrc} alt="Profile" />
          </button>
        </>
      ) : (
        <>
          <button className={location.pathname === '/login' ? 'active' : ''} onClick={()=>navigate('/login')}>Log in</button>
          <button className={location.pathname === '/signup' ? 'active' : ''} onClick={()=>navigate('/signup')}>Sign up</button>
        </>
      )}
    </div>
  )
}